import Vue from 'vue';
import Router from 'vue-router';
import { perfix } from '../../utils/common.js'
Vue.use(Router);


const Proutes = [
  {
    path: '/',
    redirect: '/index',
  },
  //首页
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index.vue'),
    meta: { requireAuth: true, name: '中国国际煤炭发展高峰论坛', isKeep: true }
  },
  //论坛介绍
  {
    path: '/forum',
    name: 'forum',
    component: () => import('../views/BBS/introduce.vue'),
    meta: { requireAuth: true, name: '论坛介绍', isKeep: true }
  },
  //参会指南
  {
    path: '/guide',
    name: 'guide',
    component: () => import('../views/BBS/guide.vue'),
    meta: { requireAuth: true, name: '参会指南', isKeep: true }
  },
  //演讲嘉宾
  {
    path: '/guestSpeaker',
    name: 'guestSpeaker',
    component: () => import('../views/BBS/guestSpeaker.vue'),
    meta: { requireAuth: true, name: '演讲嘉宾', isKeep: true }
  },
  //嘉宾详情
  {
    path: '/guestDetail',
    name: 'guestDetail',
    component: () => import('../views/BBS/guestDetail.vue'),
    meta: { requireAuth: true, name: '嘉宾详情', isKeep: false }
  },
  //主论坛
  {
    path: '/mainForum',
    name: 'mainForum',
    component: () => import('../views/schedule/mainForum.vue'),
    meta: { requireAuth: true, name: '日程安排', isKeep: false }
  },
  //报名听会
  {
    path: '/sinSpeak',
    name: 'sinSpeak',
    component: () => import('../views/signUp/sinSpeak.vue'),
    meta: { requireAuth: true, name: '报名听会', isKeep: false }
  },
  //报名发言
  {
    path: '/toSpeak',
    name: 'toSpeak',
    component: () => import('../views/signUp/toSpeak.vue'),
    meta: { requireAuth: true, name: '报名发言', isKeep: false }
  },
  // 赞助机会
  {
    path: '/sponsor',
    name: 'sponsor',
    component: () => import('../views/Sponsor/index.vue'),
    meta: { requireAuth: true, name: '赞助机会', isKeep: true }
  },
  // 下载中心
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/download/index.vue'),
    meta: { requireAuth: true, name: '下载中心', isKeep: true }
  },
  // 媒体合作
  {
    path: '/workMedia',
    name: 'workMedia',
    component: () => import('../views/media/workMedia.vue'),
    meta: { requireAuth: true, name: '媒体合作', isKeep: true }
  },
  // 论坛新闻 
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/media/news.vue'),
    meta: { requireAuth: true, name: '论坛新闻', isKeep: true }
  },
  // 新闻详情
  {
    path: '/new_detail',
    name: 'new_detail',
    component: () => import('../views/media/new_detail.vue'),
    meta: { requireAuth: true, name: '新闻详情', isKeep: false }
  },
  // 上届论坛
  {
    path: '/lastForum',
    name: 'lastForum',
    component: () => import('../views/lastForum/index.vue'),
    meta: { requireAuth: true, name: '上届论坛', isKeep: true }
  },
  // 联系我们
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/contact/contactUs.vue'),
    meta: { requireAuth: true, name: '联系我们', isKeep: true }
  },
];

const MRoutes = [
  {
    path: '/',
    redirect: '/index',
  },
  //首页
  {
    path: '/index',
    name: 'index',
    component: () => import('../../srcMobile/mViews/index.vue'),
    meta: { requireAuth: true, name: '中国国际煤炭发展高峰论坛', isKeep: true }
  },
  //
  //论坛介绍
  {
    path: '/forum',
    name: 'forum',
    component: () => import('../../srcMobile/mViews/BBS/introduce.vue'),
    meta: { requireAuth: true, name: '论坛介绍', isKeep: true }
  },

  // 上届论坛
  {
      path: '/lastForum',
      name: 'lastForum',
      component: () => import('../../srcMobile/mViews/lastForum/index.vue'),
      meta: { requireAuth: true, name: '上届论坛', isKeep: true }
    },
  // 新闻详情
  {
    path: '/new_detail',
    name: 'new_detail',
    component: () => import('../../srcMobile/mViews/media/new_detail.vue'),
    meta: { requireAuth: true, name: '新闻详情', isKeep: false }
  },
  // 赞助机会
  {
    path: '/sponsor',
    name: 'sponsor',
    component: () => import('../../srcMobile/mViews/Sponsor/index.vue'),
    meta: { requireAuth: true, name: '赞助机会', isKeep: true }
  },
  //参会指南
  {
    path: '/guide',
    name: 'guide',
    component: () => import('../../srcMobile/mViews/BBS/guide.vue'),
    meta: { requireAuth: true, name: '参会指南', isKeep: true }
  },
  // 下载中心
  {
    path: '/download',
    name: 'download',
    component: () => import('../../srcMobile/mViews/download/index.vue'),
    meta: { requireAuth: true, name: '下载中心', isKeep: true }
  },
  //合作媒体
  {
    path: '/workMedia',
    name: 'workMedia',
    component: () => import('../../srcMobile/mViews/media/workMedia.vue'),
    meta: { requireAuth: true, name: '媒体合作', isKeep: true }
  },
    // 联系我们
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../../srcMobile/mViews/contact/contactUs.vue'),
      meta: { requireAuth: true, name: '联系我们', isKeep: true }
    },
  // 论坛新闻 
  {
    path: '/news',
    name: 'news',
    component: () => import('../../srcMobile/mViews/media/news.vue'),
    meta: { requireAuth: true, name: '论坛新闻', isKeep: true }
  },
    //主论坛
    {
      path: '/mainForum',
      name: 'mainForum',
      component: () => import('../../srcMobile/mViews/schedule/mainForum.vue'),
      meta: { requireAuth: true, name: '日程安排', isKeep: false }
    },
     //报名听会
  {
    path: '/sinSpeak',
    name: 'sinSpeak',
    component: () => import('../../srcMobile/mViews/signUp/sinSpeak.vue'),
    meta: { requireAuth: true, name: '报名听会', isKeep: false }
  },
  //报名发言
  {
    path: '/toSpeak',
    name: 'toSpeak',
    component: () => import('../../srcMobile/mViews/signUp/toSpeak.vue'),
    meta: { requireAuth: true, name: '报名发言', isKeep: false }
  },
  //演讲嘉宾
  {
    path: '/guestSpeaker',
    name: 'guestSpeaker',
    component: () => import('../../srcMobile/mViews/BBS/guestSpeaker.vue'),
    meta: { requireAuth: true, name: '演讲嘉宾', isKeep: true }
  },
  //嘉宾详情
  {
    path: '/guestDetail',
    name: 'guestDetail',
    component: () => import('../../srcMobile/mViews/BBS/guestDetail.vue'),
    meta: { requireAuth: true, name: '嘉宾详情', isKeep: false }
  },


];
let routes = [];
perfix() ? routes = [...MRoutes] : routes = [...Proutes];

export default new Router({
  routes,
  mode: 'hash',
});

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};




